<template>
  <div id="onboarding-camera">
    <LockLoader
      v-if="!cameraOn"
      asset="o-camera-icon.svg"
      />
    <CameraHeader
      v-show="cameraOn"
      @click="stepBack"
      :headerText="headerText"
      :canBackPage="canBackPage"
    />
    <div v-show="cameraOn && !hideFooter" class="footer-wrapper">
      <div class="footer" :class="{ centered: !inSelfieStep }">
        <div @click="openHelp" v-if="inSelfieStep" class="left">
          <Icon v-if="showSelfieHelp" name="help-white" />
        </div>

        <div @click="takePhoto" :class="{ disabled: !cameraOn }">
          <Icon name="camera-border"/>
        </div>

        <div class="right"></div>
      </div>
    </div>

    <CameraBox
      v-show="cameraOn"
      class="camera"
      ref="camera"
      @error="onError"
      @start="onStart"
      :selfie="inSelfieStep"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/components/ui/AppIcon.vue';

import CameraHeader from './CameraHeader.vue';
import CameraBox from './CameraBox.vue';
import LockLoader from '../../../components/common/LockLoader.vue';

export default {
  name: 'onboarding-camera',
  components: { CameraHeader, Icon, CameraBox, LockLoader },
  props: {
    headerText: {
      type: String,
      required: true,
    },
    onBackGoTo: {
      type: String,
      required: false,
    },
    canBackPage: {
      type: Boolean,
      required: false,
      default: true,
    },
    inSelfieStep: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    showSelfieHelp: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    cameraOn: false,
    isSelfie: false,
  }),
  computed: {
    ...mapState('onboarding', ['cameraOpened']),
  },
  methods: {
    stepBack() {
      this.$router.replace({
        name: this.onBackGoTo,
        query: this.$route.query,
      });
    },
    getMobileOS() {
      const { userAgent } = navigator;
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        return 'iOS';
      }
      return 'Other';
    },
    onError(e) {
      if (e.isDeniedError) {
        const mobileOS = this.getMobileOS();
        if (mobileOS === 'Android') {
          this.$router.replace({
            name: 'onboarding-camera-error-android',
            query: this.$route.query,
          });
        } else {
          this.$router.replace({
            name: 'onboarding-camera-error-ios',
            query: this.$route.query,
          });
        }
      } else {
        // eslint-disable-next-line no-alert
        alert('Erro inesperado, entre em contato com o nosso suporte');
        this.$router.replace({
          name: 'onboarding-error',
          query: this.$route.query,
        });
      }
    },
    onStart() {
      this.cameraOn = true;
    },
    takePhoto() {
      this.$emit('sendImg', this.$refs.camera.capture());
      this.closeCamera();
    },
    openHelp(evt) {
      this.$emit('openHelp', evt);
    },
    closeCamera() {
      this.$refs.camera.closeCamera();
    },
  },
  async mounted() {
    await this.$refs.camera.openCamera();
  },
};
</script>

<style lang="scss" scoped>
  #onboarding-camera {
    touch-action: manipulation;
    height: 100vh;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .footer-wrapper {
    margin: 0;
    bottom: 10px;
    left: 0;
    box-sizing: border-box;
    position: fixed;
    width: 100%;
    height: 88px;
    padding: 20px 24px;

    .footer {
      display: flex;
      align-items: center;

      &.centered {
        justify-content: center;

        .left, .right {
          flex: none;
        }
      }

      div {
        display: flex;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }

      .left, .right {
        flex: 1;
      }
    }
  }

  .invisible {
    visibility:hidden;
  }

  .camera {
    z-index: -1;
  }
</style>
